import { useEffect, useState } from 'preact/hooks'
import { SITE_VARIABLES } from './variables'

const setThemeVars = (paletteData: { colors: any; fonts: Array<Record<string, unknown>>; typography: any }) => {
    const { bigger, normal, large, big, tiny } = SITE_VARIABLES.TYPOGRAPHY
    return {
        ...SITE_VARIABLES,
        COLORS: {
            ...SITE_VARIABLES.COLORS,
            DARK: paletteData?.colors?.primary ?? SITE_VARIABLES.COLORS.DARK,
            LIGHT: paletteData?.colors?.secondary ?? SITE_VARIABLES.COLORS.LIGHT,
            BLACK: paletteData?.colors?.black ?? SITE_VARIABLES.COLORS.BLACK,
            PRIMARY: paletteData?.colors?.primary ?? SITE_VARIABLES.COLORS.PRIMARY,
            SECONDARY: paletteData?.colors?.secondary ?? SITE_VARIABLES.COLORS.SECONDARY,
            DARKGREY: paletteData?.colors?.darkGrey ?? SITE_VARIABLES.COLORS.DARKGREY,
        },
        TEXT_FONT_FAMILY: {
            ...SITE_VARIABLES.TEXT_FONT_FAMILY,
            DEFAULT: paletteData?.fonts?.[0]?.family
                ? paletteData.fonts[0].family + ', Arial, sans-serif'
                : SITE_VARIABLES.TEXT_FONT_FAMILY.DEFAULT,
            TITLE: paletteData?.fonts?.[1]?.family
                ? paletteData.fonts[1].family + ', Arial, sans-serif'
                : SITE_VARIABLES.TEXT_FONT_FAMILY.TITLE,
        },
        TYPOGRAPHY: {
            bigger: {
                fontFamily: paletteData.typography.bigger.fontFamily ?? bigger.fontFamily,
                fontWeight: paletteData.typography.bigger.fontWeight ?? bigger.fontWeight,
                screenSizes: {
                    small: `${paletteData.typography.bigger.screenSizes.medium}px` ?? bigger.screenSizes.small,
                    medium: `${paletteData.typography.bigger.screenSizes.medium}px` ?? bigger.screenSizes.medium,
                    large: `${paletteData.typography.bigger.screenSizes.large}px` ?? bigger.screenSizes.large,
                },
            },
            large: {
                fontFamily: paletteData.typography.large.fontFamily ?? large.fontFamily,
                fontWeight: paletteData.typography.large.fontWeight ?? large.fontWeight,
                screenSizes: {
                    small: `${paletteData.typography.large.screenSizes.medium}px` ?? large.screenSizes.small,
                    medium: `${paletteData.typography.large.screenSizes.medium}px` ?? large.screenSizes.medium,
                    large: `${paletteData.typography.large.screenSizes.large}px` ?? large.screenSizes.large,
                },
            },
            big: {
                fontFamily: paletteData.typography.big.fontFamily ?? big.fontFamily,
                fontWeight: paletteData.typography.big.fontWeight ?? big.fontWeight,
                screenSizes: {
                    small: `${paletteData.typography.big.screenSizes.medium}px` ?? big.screenSizes.small,
                    medium: `${paletteData.typography.big.screenSizes.medium}px` ?? big.screenSizes.medium,
                    large: `${paletteData.typography.big.screenSizes.large}px` ?? big.screenSizes.large,
                },
            },
            normal: {
                fontFamily: paletteData.typography.normal.fontFamily ?? normal.fontFamily,
                fontWeight: paletteData.typography.normal.fontWeight ?? normal.fontWeight,
                screenSizes: {
                    small: `${paletteData.typography.normal.screenSizes.small}px` ?? normal.screenSizes.small,
                    medium: `${paletteData.typography.normal.screenSizes.medium}px` ?? normal.screenSizes.medium,
                    large: `${paletteData.typography.normal.screenSizes.large}px` ?? normal.screenSizes.large,
                },
            },
            tiny: {
                fontFamily: paletteData.typography.tiny.fontFamily ?? tiny.fontFamily,
                fontWeight: paletteData.typography.tiny.fontWeight ?? tiny.fontWeight,
                screenSizes: {
                    small: `${paletteData.typography.tiny.screenSizes.small}px` ?? tiny.screenSizes.small,
                    medium: `${paletteData.typography.tiny.screenSizes.medium}px` ?? tiny.screenSizes.medium,
                    large: `${paletteData.typography.tiny.screenSizes.large}px` ?? tiny.screenSizes.large,
                },
            },
        },
    }
}

declare global {
    interface Window {
        mmClientApi?: Array<any> | { push: (eventName: string, params: any) => void }
    }
}

export const useSiteVars = () => {
    const [siteVars, setSiteVars] = useState(SITE_VARIABLES)

    useEffect(() => {
        window.mmClientApi = window.mmClientApi || []
        window.mmClientApi.push('getPaletteData', (paletteData: any) => {
            setSiteVars(setThemeVars(paletteData))
        })
    }, [])

    return siteVars
}
